import { createGlobalStyle } from 'styled-components';

export const FontsProvider = createGlobalStyle`
  @font-face {
    font-family: 'Haffer';
    font-style: normal;
    font-display: block;
    src:
      url(/fonts/haffer/HafferXHVF.woff2) format('woff2'),
      url(/fonts/haffer/HafferXHVF.woff) format('woff');
  }
  @font-face {
    font-family: 'Haffer';
    font-style: italic;
    font-display: block;
    src:
      url(/fonts/haffer/HafferXHVFItalics.woff2) format('woff2'),
      url(/fonts/haffer/HafferXHVFItalics.woff) format('woff');
  }
`;
